import React from "react";
import { Helmet } from "react-helmet-async";

const SITE_URL = "https://www.steadypathfunding.com";
const DEFAULT_IMAGE = `${SITE_URL}/og-default.png`;
const GSC_VERIFICATION = process.env.REACT_APP_GSC_VERIFICATION || "";

// Per-page SEO helper. Renders <title>, meta description, canonical,
// Open Graph, Twitter card, and optional JSON-LD.
export const Seo = ({
  title,
  description,
  path = "/",
  image = DEFAULT_IMAGE,
  type = "website",
  publishedTime,
  jsonLd = null,
  noindex = false,
}) => {
  const fullTitle = title
    ? `${title} · Steady Path Funding`
    : "Steady Path Funding — Business loans, honestly brokered";
  const desc =
    description ||
    "Independent business finance brokerage. SBA, lines of credit, revenue financing, equipment, working capital, MCA. One application, 75+ lenders shopped.";
  const url = `${SITE_URL}${path}`;

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={desc} />
      <link rel="canonical" href={url} />
      {noindex && <meta name="robots" content="noindex, nofollow" />}
      {GSC_VERIFICATION && (
        <meta name="google-site-verification" content={GSC_VERIFICATION} />
      )}

      {/* Open Graph */}
      <meta property="og:type" content={type} />
      <meta property="og:site_name" content="Steady Path Funding" />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={desc} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={image} />
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height" content="630" />
      {publishedTime && <meta property="article:published_time" content={publishedTime} />}

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={desc} />
      <meta name="twitter:image" content={image} />

      {jsonLd && <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>}
    </Helmet>
  );
};

export default Seo;
